import gql from 'graphql-tag';

export const INVENTORY_OPTION_FRAGMENT = gql`
  fragment InventoryOptionFields on InventoryOption {
    inventoryOptionId
    code
    name
    description
    accountId
    createdDateTime
    modifiedDateTime
    pricing {
      inventoryOptionPricingId
      inventoryOptionId
      year
      make
      model
      modelBase
      cost
    }
  }
`;

export const INVENTORY_OPTION_MATCH_FRAGMENT = gql`
  fragment InventoryOptionMatchFields on InventoryOptionMatch {
    inventoryOptionId
    code
    name
    description
    cost
    matchedPricing {
      inventoryOptionPricingId
      inventoryOptionId
      year
      make
      model
      modelBase
      cost
    }
  }
`;
